import '../controllers/landing_pages/skin_need_step2/main.js'
